<template>
  <div>
    <div class="col">
    <cc-form-input
      label-cols
      :label="$t('common:single_word.show','Show') + ':'"
    >
      <b-form-checkbox class="text-right green-checkbox mt-2"
        data-testid="cboDaterangeVariableToggle"
        v-model="enabled"
        switch
        >
      </b-form-checkbox>

    </cc-form-input>
  </div>
  <div class="col mb-3">
      <cc-date-range-picker v-if="exactRange"
        v-model="datePickerValue"
        opens="left"
        :linked-calendars="false"
        :append-to-body="true"
        :show-dropdowns="true"
        :ranges="false"
        :auto-apply="false"
        :time-picker="true">
      </cc-date-range-picker>

      <div v-if="!exactRange"
        style="display: flex; flex-direction: row; align-items: center;">
        <div style="flex: 0 0; margin-right: 10px;">{{$t('common:single_word.last','Last')}}:</div>
        <div style="flex: 0 0 100px; margin-right: 10px;">
          <b-form-input
                data-testid="txtDaterangeRelativeVariable"
               :min="1" no-wheel :step="1" number v-model.number="relativeValue" :state="relativeValueState"></b-form-input>
        </div>
        <div style="flex: 0 0 100px;">
          <b-form-select data-testid="ddlDaterangeRelativeVariable" :options="relativeOptions" v-model="relativeUnit"></b-form-select>
        </div>
      </div>

      <div style="margin-top: 15px;">
        <b-form-checkbox switch
          data-testid="cboDaterangeExactVariableToggle"
          v-model="exactRange">
          {{ $t('common:phrase.exact_date_range','Exact Date Range') }}
        </b-form-checkbox>
      </div>
    </div>
  </div>

</template>

<script>
import daterangeConstants from "../shared/daterange-constants"
export default {
  name : 'daterange-variable-option',
  props : {
    value : {
      type : Object
    }
  },
  data (){
    return {
      exactRange: true,
      datePickerValue: {
        startDate: new Date(new Date().getTime() - (3 * 24 * 60 * 60 * 1000)),
        endDate: new Date(),
      },
      outputValue: {},
      relativeOptions: daterangeConstants.relativeOptions,
      relativeUnit: 'days',
      relativeValue: 3,

      enabled : false,
      TIME_RANGE_TYPE : daterangeConstants.time_range_type
    }
  },
  methods: {
    emitValue() {
      if (this.exactRange) {
        this.$emit('input', {
          enabled : this.enabled,
          type: this.TIME_RANGE_TYPE.exactDateRange,
          options: {
            epochStart: this.datePickerValue.startDate.getTime(),
            epochEnd: this.datePickerValue.endDate.getTime(),
          },
        });
      } else { // relativeRange
        if (this.relativeValueState === false) {
          this.$emit('input', {
            type: 'error',
            message: this.$t('common:validation.greater_than_0','Value must be greater than zero'),
          });
        } else {
          this.$emit('input', {
            enabled : this.enabled,
            type: this.TIME_RANGE_TYPE.relativeDateRange,
            options: {
              milliseconds: Number(this.relativeValue) * this.relativeOptions.find(e => e.value === this.relativeUnit).millis,
              unit: this.relativeUnit,
              value: this.relativeValue,
            }
          });
        }
      }
    },
    refresh() {
      this.enabled = this.value.enabled;
      if (this.value.type === this.TIME_RANGE_TYPE.exactDateRange) {
        this.exactRange = true;
        this.datePickerValue = {
          startDate: new Date(this.value.options.epochStart),
          endDate: new Date(this.value.options.epochEnd),
        };
      } else if (this.value.type === this.TIME_RANGE_TYPE.relativeDateRange) {
        this.exactRange = false;
        this.relativeUnit = this.value.options.unit;
        this.relativeValue = this.value.options.value;
      } else { // error

      }
    },

  },
  computed: {
    relativeValueState() {
      if (this.relativeValue === '' || isNaN(this.relativeValue) || this.relativeValue <= 0) {
        return false;
      } else {
        return null;
      }
    },

  },
  watch: {
    datePickerValue(newVal, oldVal) {
      this.emitValue();
    },
    value(newVal, oldVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.refresh();
      }
    },
    relativeValue(newVal) {
      this.emitValue();
    },
    relativeUnit() {
      this.emitValue();
    },
    exactRange() {
      this.emitValue();
    },
    enabled() {
      this.emitValue();
    },
  },
  mounted() {
    this.refresh();
  },

}
</script>

